module.exports = __webpack_public_path__ + "static/media/reallypoor-selected.c9e9ec3a.svg";